import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import SeoHead from "@/components/SeoHead";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <SeoHead
        title="Page Not Found - Debug"
        description="The page you are looking for does not exist. Return to Debug homepage for expert software development and debugging services."
        keywords="404, page not found, debug software, development services"
        noindex={true}
      />
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">This page has not been generated</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="mt-8 inline-block bg-[rgb(0,0,139)] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[rgb(0,0,100)] transition-all cursor-pointer whitespace-nowrap"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}